import { createContext, useState, useEffect } from "react";
import { fetchNotificationApi, notificationReadActionApi, notificationReadActionApiAll } from "../services/Notification"
import { raiseTicketApi, fetchTicketsApi, fetchViewTicketsIdApi, resolveApi } from '../services/TicketsApi'
import { useLocation, useNavigate } from "react-router-dom";
import { applyJob, toggleJobSave } from "../services/Candidate Portal/jobApplications";

export const DataProvider = createContext()

const ContextProvider = ({ children }) => {
    const location = useLocation()
    const navigate = useNavigate()
    const BeURL = process.env.REACT_APP_BeURL
    const [isAuth, setIsAuth] = useState(null)
    const [currentUser, setCurrentUser] = useState(null);
    const [maintenanceMode, setMaintenanceMode]=useState(false)

    const [jobId,setJobId]=useState(null)
    const [status ,setStatus]=useState("")
    const [apply,setApply]=useState("")
    const [isSaving,setSavingJob]=useState(false)
    const [login, setLogin] = useState(false)
    const [signUpResume, setSignUpResume]=useState(false)
    const id = jobId

    const [popup, setPopup] = useState({
        visible: false,
        message: '',
        type: 'alert', // 'alert' | 'confirm'
        resolve: () => { },
    });

    const showAlert = (message) =>
        new Promise((resolve) => {
            setPopup({
                visible: true,
                message,
                type: 'alert',
                resolve,
            });
        });

    const showConfirm = (message) =>
        new Promise((resolve) => {
            setPopup({
                visible: true,
                message,
                type: 'confirm',
                resolve,
            });
        });


    const handlePopupConfirm = () => {
        popup.resolve(true);
        setPopup((prev) => ({ ...prev, visible: false }));
    };

    const handlePopupCancel = () => {
        popup.resolve(false);
        setPopup((prev) => ({ ...prev, visible: false }));
    };

    useEffect(() => {
        fetch(`${BeURL}/checkauth`, {
            credentials: "include"
        })
            .then(res => res.json())
            .then(data => {
                setMaintenanceMode(false)
                if (data.success) {
                    setIsAuth(true)
                    setCurrentUser(data.user)
                }
                else {
                    setIsAuth(false)
                    setCurrentUser({})
                }
            })
            .catch(err => {
                setMaintenanceMode(true)
                setIsAuth(null)
                setCurrentUser(null)
                console.log("Erron in fetching User:", err)
                alert("Trouble in connecting to the Server, please try again later.")
            })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])


    const [getNotification, setGetNotification] = useState([]);
    const [getTickets, setGetTickets] = useState([]);
    const [getTicketsViewId, setGetTicketsViewId] = useState({})

    const handleNotification = (perPage, currentPage, setTotalPages, setTotalCount) => {
        fetchNotificationApi(setGetNotification, BeURL, showAlert, perPage, currentPage, setTotalPages, setTotalCount);
    };

    const notificationReadAction = (id) => {
        notificationReadActionApi(id, BeURL)
    }

    const notificationReadActionAll = (id) => {
        notificationReadActionApiAll(id, BeURL)
    }

    const RaiseTicket = (raiseTicketFormData) => {
        raiseTicketApi(raiseTicketFormData, BeURL)
    }

    const handleTickets = (perPage, currentPage, setTotalPages, setTotalCount) => {
        fetchTicketsApi(setGetTickets, BeURL, perPage, currentPage, setTotalPages, setTotalCount);
    };

    const handleViewTicketsId = (ticketId) => {
        fetchViewTicketsIdApi(setGetTicketsViewId, ticketId, BeURL)
    }

    const handleResolve = (ticketId) => {
        resolveApi(ticketId, BeURL)
    }

    useEffect(() => {
        if(!currentUser) return
        const role = currentUser?.role
        if (BeURL && isAuth && role !== "admin" &&  (role === "employer" && !location.pathname.startsWith('/account'))) {
            fetch(`${BeURL}/check-profile`, {
                method: 'GET',
                credentials: "include",
            })
                .then((res) => res.json())
                .then((data) => {
                    if (data.success === true && data.requiredUpdation === true) {
                    if(role === "employer"){
                            navigate(
                                `/account?updateStatus=1`,
                                { replace: true }
                            );
                        }
                        showAlert(data.message);
                    }
                    else if(data.success === false){
                        console.log(data.message)
                    }
                })
                .catch((err) => {
                    console.error("Error in checking User profile:", err);
                    alert("Trouble in connecting to the Server, please try again later.");
                });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isAuth, BeURL, currentUser, location.pathname]);



    useEffect(() => {
        if(!currentUser) return
        const role = currentUser?.role
        if (BeURL && isAuth && role === "job-seeker"){
            fetch(`${BeURL}/check-resume`, {
                method : 'GET',
                credentials: "include",
            })
                .then((res) => res.json())
                .then((data) => {
                    if (data.success && (data.requiredResume || data.isValidCandidate === false)) {
                        navigate(`/upload-resume${data.isValidCandidate === false ? "?newUser=true": ""}`)
                    }
                })
                .catch((err) => {
                    console.error("Error in checking User profile:", err);                
                });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isAuth, BeURL, currentUser, location.pathname]);


    useEffect(()=>{
        if ((login || signUpResume) && isAuth && ["job-seeker"].includes(currentUser?.role) && status === "apply"){
            applyJob(BeURL, showAlert, id , status)
        }
        else if ((login || signUpResume) && isAuth && ["job-seeker"].includes(currentUser?.role) && status === "save"){
            toggleJobSave(BeURL, showAlert, id, isSaving, status)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [login, currentUser, isAuth, signUpResume ])


    const formatPeriod = (isoDateStr) => {
        if (!isoDateStr) return { year: "", month: "", date: "" };

        const date = new Date(isoDateStr);
        const year = date.getFullYear().toString();
        const month = (date.getMonth() + 1).toString().padStart(2, "0");
        const day = date.getDate().toString().padStart(2, "0");

        // Month short names
        const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

        // If default 01-01 → skip month/day
        if (month === "01" && day === "01") {
            return { year, month: "", date: "" };
        } else {
            return { year, month: monthNames[date.getMonth()], date: day };
        }
    };


    const data = {
        BeURL, isAuth, setIsAuth, currentUser, setCurrentUser, showAlert, showConfirm, popup, handlePopupConfirm, handlePopupCancel,
        getNotification, getTickets, getTicketsViewId, handleNotification, notificationReadAction, notificationReadActionAll, RaiseTicket, handleTickets, handleViewTicketsId, handleResolve, formatPeriod, maintenanceMode, jobId, setJobId, status, setStatus, setApply, setSavingJob, apply, isSaving, setLogin, setSignUpResume
}

    return (
        <DataProvider.Provider value={data}>
            {children}
        </DataProvider.Provider>
    )
}

export default ContextProvider